module.exports = __webpack_public_path__ + "img/jt_logo.287ae23c.png";